import {configureSentry} from './Sentry';
import {ReactMount} from './react-mount';

if (import.meta.env.VITE_SENTRY_DSN) {
    configureSentry({
        dsn: import.meta.env.VITE_SENTRY_DSN,
    });
}

export {ReactMount};
